module.exports = __webpack_public_path__ + "static/img/homepage-header-GarretG.bd6d3aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner/homepage-header-GarretG.jpg
// module id = 6EJN
// module chunks = 35